import React from 'react';
import { Radar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
  ChartData,
  ChartOptions
} from 'chart.js';

// Register Chart.js components
ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
);

interface RadarChartProps {
  data: ChartData<'radar'>;
  options?: ChartOptions<'radar'>;
  height?: number;
  width?: number;
}

export const RadarChart: React.FC<RadarChartProps> = ({ 
  data, 
  options = {}, 
  height = 300,
  width = 300
}) => {
  const defaultOptions: ChartOptions<'radar'> = {
    scales: {
      r: {
        min: 0,
        max: 10,
        ticks: {
          stepSize: 2
        }
      }
    },
    elements: {
      line: {
        borderWidth: 2
      }
    },
    ...options
  };

  return (
    <div style={{ height, width }}>
      <Radar data={data} options={defaultOptions} />
    </div>
  );
};
